// Sentry frontend scaffold — no-op until VITE_SENTRY_DSN is set.
// To activate:
//   1. npm i @sentry/react @sentry/tracing  (in /civix/web)
//   2. set VITE_SENTRY_DSN in .env to your project's DSN
//   3. rebuild — that's it. Errors and React component stack traces flow to Sentry.

let initialized = false;
let SentryRef = null;

export async function initFrontendSentry() {
  if (initialized) return SentryRef;
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn || dsn === 'placeholder') {
    // No-op: leaves the app fully functional with zero overhead.
    initialized = true;
    return null;
  }
  try {
    // Use a runtime-resolved specifier so Rollup doesn't try to bundle
    // the optional Sentry SDK at build time.
    const pkg = /* @vite-ignore */ '@sentry/' + 'react';
    const Sentry = await import(/* @vite-ignore */ pkg);
    Sentry.init({
      dsn,
      environment: import.meta.env.MODE || 'production',
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.05,
      replaysOnErrorSampleRate: 1.0,
      release: 'civix-web@1.0.0',
    });
    SentryRef = Sentry;
    initialized = true;
    return Sentry;
  } catch (e) {
    // Package not installed — that's fine, we keep this optional.
    console.warn('[CIVIX] Sentry DSN set but @sentry/react not installed. Run: npm i @sentry/react @sentry/tracing');
    initialized = true;
    return null;
  }
}

export function captureFrontendException(err, ctx) {
  if (SentryRef) {
    try { SentryRef.captureException(err, { extra: ctx }); } catch {}
  } else {
    // Fallback: still log to console so crashes are visible during dev.
    console.error('[CIVIX-error]', err, ctx || '');
  }
}

// Initialize eagerly — safe no-op when DSN not set.
initFrontendSentry();
